import { AlertCriterion } from '@interfaces/models/alertCriterion';
import { useQuery } from '@tanstack/react-query';
import useUser from '@hooks/user/use-user';
import { useBucket } from '@context/bucket.context';
import logger from '@helpers/utils/logger/client';
import AlertsService, { AlertsExistsResponse } from '@services/alerts-service';
import { AlertsCatalogQueryKeys } from '@enums/react-query-keys';
import { ApiResponse } from '@interfaces/api';

const useCheckAlertExistence = ({
  alertCriteria,
  onSuccess,
}: {
  alertCriteria: AlertCriterion[];
  onSuccess: (response: ApiResponse<AlertsExistsResponse>) => void;
}) => {
  const { isAuthenticated } = useUser();
  const { isFeatureEnabled } = useBucket();
  const isAlertsExistsPlpEnabled = isFeatureEnabled((f) => !!f.enableAlertsExistsPlp, true);

  useQuery<ApiResponse<AlertsExistsResponse>>({
    queryKey: [AlertsCatalogQueryKeys.CHECK_EXISTENCE, alertCriteria],
    queryFn: () => AlertsService.checkAlertExistence(alertCriteria),
    enabled: !!(isAuthenticated && isAlertsExistsPlpEnabled),
    onSuccess,
    onError: (error) => {
      logger.error('/alerts/exists service error', error);
    },
    retry: false,
  });
};

export default useCheckAlertExistence;
